import React from 'react';
import Button, { ButtonProps } from './Button';
import SmartLink from './SmartLink';

export interface ButtonLinkProps extends ButtonProps {
  to: string;
  linkClassName?: string;
}

export const ButtonLink = ({
  to,
  linkClassName,
  ...restProps
}: ButtonLinkProps): React.ReactElement => (
  <SmartLink to={to} tabIndex={-1} className={linkClassName}>
    <Button {...restProps}></Button>
  </SmartLink>
);
